// const API_BASE_URL = "https://api.abrsvs.in";
// // const API_BASE_URL = "http://localhost:8095";

// // Submit Admission Form
// export const submitAdmissionForm = async (formData) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/api/admissions`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(formData),
//     });

//     if (!response.ok) {
//       throw new Error("Submission failed. Please try again.");
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("Error submitting admission form:", error);
//     throw error;
//   }
// };

// // Submit Staff Hiring Form
// export const submitStaffHiringForm = async (formData) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/api/hiring-staff`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(formData),
//     });

//     if (!response.ok) {
//       throw new Error("Submission failed. Please try again.");
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("Error submitting staff hiring form:", error);
//     throw error;
//   }
// };

// // Login User
// export const loginUser = async (userId, password) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/api/login`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ userId, password }),
//     });

//     const data = await response.json();

//     if (!response.ok) {
//       throw new Error("Invalid login credentials");
//     }

//     return data;
//   } catch (error) {
//     console.error("Error logging in:", error);
//     throw error;
//   }
// };

// // Get Admissions
// export const getAdmissions = async () => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/api/admissions/skguce1122338899001190cstdc0`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       credentials: "include", // To send JSESSIONID cookie
//     });

//     if (!response.ok) {
//       throw new Error("Failed to fetch admissions");
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("Error fetching admissions:", error);
//     throw error;
//   }
// };

// // Update Admission
// export const updateAdmission = async (id, updatedData) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/api/admissions/skguce1122338899001190cstdc12/${id}`, {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(updatedData),
//     });

//     if (!response.ok) {
//       throw new Error("Failed to update admission");
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("Error updating admission:", error);
//     throw error;
//   }
// };

// // Delete Admission
// export const deleteAdmission = async (id) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/api/admissions/skguce1122338899001190cstdc12001/${id}`, {
//       method: "DELETE",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });

//     if (!response.ok) {
//       throw new Error("Failed to delete admission");
//     }

//     // Check if there is a response body before parsing JSON
//     const text = await response.text();
//     return text ? JSON.parse(text) : {}; // Return empty object if no JSON
//   } catch (error) {
//     console.error("Error deleting admission:", error);
//     throw error;
//   }
// };


// // Get Hiring Staff
// export const getHiringStaff = async () => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/api/hiring-staff/skg121212131234345o`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });

//     if (!response.ok) {
//       throw new Error("Failed to fetch hiring staff data");
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching hiring staff:", error);
//     throw error;
//   }
// };

// // Export all functions
// export default {
//   submitAdmissionForm,
//   submitStaffHiringForm,
//   loginUser,
//   getAdmissions,
//   updateAdmission,
//   deleteAdmission,
//   getHiringStaff,
// };


const API_BASE_URL = "https://api.abrsvs.in";
// const API_BASE_URL = "http://localhost:8095"; // For local development

// Helper function for API requests
const makeRequest = async (endpoint, method, body = null, requiresAuth = false) => {
  const headers = {
    "Content-Type": "application/json",
  };

  const config = {
    method,
    headers,
    credentials: requiresAuth ? "include" : "omit",
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `API request failed with status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`API Error (${method} ${endpoint}):`, error);
    throw error;
  }
};

// Admission Services
export const submitAdmissionForm = async (formData) => {
  return makeRequest("/api/admissions", "POST", formData);
};

export const getAdmissions = async () => {
  return makeRequest("/api/admissions/skguce1122338899001190cstdc0", "GET", null, true);
};

export const updateAdmission = async (id, updatedData) => {
  return makeRequest(`/api/admissions/skguce1122338899001190cstdc12/${id}`, "PUT", updatedData);
};

export const deleteAdmission = async (id) => {
  return makeRequest(`/api/admissions/skguce1122338899001190cstdc12001/${id}`, "DELETE");
};

// Staff Hiring Services
export const submitStaffHiringForm = async (formData) => {
  return makeRequest("/api/hiring-staff", "POST", formData);
};

export const getHiringStaff = async () => {
  return makeRequest("/api/hiring-staff/skg121212131234345o", "GET");
};

// Auth Services
export const loginUser = async (userId, password) => {
  return makeRequest("/api/login", "POST", { userId, password });
};

// Service Object
const GurukulService = {
  submitAdmissionForm,
  submitStaffHiringForm,
  loginUser,
  getAdmissions,
  updateAdmission,
  deleteAdmission,
  getHiringStaff,
};

export default GurukulService;




